import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as rootQueries } from "domains/postGig/views/Root/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; search: MarketplaceSearch };

export const queries = (input: QueriesInput): Array<WarmableQuery> => {
  const isOpen = input.search.post_gig_type != null;
  return rootQueries(input).map((query) => ({ ...query, enabled: isOpen && query.enabled !== false }));
};
